import GdAutosuggest from './Autosuggest.vue';
import GdButton from './Button.vue';
import GdCheckbox from './Checkbox.vue';
import ColorPicker from './ColorPicker.vue';
import GdCounter from './Counter.vue';
import DateTimePicker from './DateTimePicker.vue';
import GdDropdown from './Dropdown.vue';
import EmbedArea from './EmbedArea.vue';
import FontAwesomePicker from './FontAwesomePicker.vue';
import HtmlPanel from './HtmlPanel.vue';
import ImagePickerModal from './ImagePickerModal.vue';
import MultiSelect from './MultiSelect.vue';
import PluginStyle from './PluginStyle.vue';
import GdRadio from './Radio.vue';
import GdSeparator from './Separator.vue';
import GdSlider from './Slider.vue';
import SortableListPlain from './SortableListPlain.vue';
import TextInput from './TextInput.vue';
import TextArea from './TextArea.vue';
import GdToggle from './Toggle.vue';

export default {
  GdButton,
  GdDropdown,
  HtmlPanel,
  TextInput,
  TextArea,
  MultiSelect,
  GdCheckbox,
  GdAutosuggest,
  GdSlider,
  GdSeparator,
  ColorPicker,
  ImagePickerModal,
  GdToggle,
  GdRadio,
  SortableListPlain,
  FontAwesomePicker,
  EmbedArea,
  PluginStyle,
  GdCounter,
  DateTimePicker
};